import createTabManager from './tabManagerFactory'
import tabs from 'components/Customer/tabs'

const customerTabs = createTabManager(tabs)

export default customerTabs



// WEBPACK FOOTER //
// ./client/store/modules/tabs/customerTabs.js